// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3JRfF","title":"BackImages_title__10rMt","images":"BackImages_images__39wgH"};